import React, { useEffect, useState } from "react";
import { PaymentRequestButtonElement, useElements, useStripe } from "@stripe/react-stripe-js";
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { xcelBaseURL, transactionBaseUrl } from '../../lib/axiosService.js';

const ApplePay = () => {
  const [paymentRequest, setPaymentRequest] = useState(null);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [decryptedData, setDecryptedData] = useState(null);
  const secretKey = "etranzactglobalresourceapplepay";

   /**
   * This is how to make an api call to an endpoint on the backend.
   * From this implementation we have two different base urls set in the axiosService.js file pointing to two different services.
   * 
   */

  // useEffect(() => {
  //   xcelBaseURL.get('/path/to/endpoint')
  //     .then((response) => {
  //       // setData(response.data);
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data from general API:', error);
  //     });
  // }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedData = urlParams.get("data");

    if (encryptedData) {
      const decodedEncryptedData = decodeURIComponent(encryptedData);
      const bytes = CryptoJS.AES.decrypt(decodedEncryptedData, secretKey);
      const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setDecryptedData(decrypted);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(decryptedData) {
      if(!stripe || !elements) {
        return;
      }
      const pr = stripe.paymentRequest({
        country: decryptedData.alpha2CountryCode,
        currency: decryptedData.currency,
        total: {
          label: "Total Amount",
          amount: decryptedData.amount * 100,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });
      pr.canMakePayment().then((result) => {
        if(result) {
          setPaymentRequest(pr);
        } else {
          toast.error("Payment can not be made on this device.");
        }
      })
  
      pr.on("paymentmethod", async (e) => {
        let payment_method = '';
        const paymentMethod = e.paymentMethod.card.wallet.type;

        if (paymentMethod === 'apple_pay') {
          payment_method = 'Apple Pay';
        } else if (paymentMethod === 'google_pay') {
          payment_method = 'Google Pay';
        } else {
          payment_method = paymentMethod;
        }

        const clientSecret = decryptedData.client_secret
        const {error, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret, {
            payment_method: e.paymentMethod.id,
          }, {
            handleActions: false,
          },
        )
        
        if (error) {
          e.complete('fail');
          toast.error('Payment Failed!');
          return;
        }
  
        e.complete('success');
        if (paymentIntent.status === 'requires_action') {
          stripe.confirmCardPayment(clientSecret)
        }

        if (paymentIntent.status === 'succeeded') {
          toast.success('Payment Successful!');
          navigate('/success', {
            state: {
              sumTotal: decryptedData.amount,
              currency: decryptedData.merchant.currency,
              reference: decryptedData.reference,
              merchant: decryptedData.merchant,
              customerName: decryptedData.customerName,
              paymentMethod: payment_method,
            },
          });
        }
      })
    }
  }, [stripe, elements, decryptedData, navigate])

  // useEffect(() => {
  //   if (paymentRequest && decryptedData) {
  //     const interval = setInterval(() => {
  //       try {
  //         paymentRequest.show()
  //           .then(() => {
  //             clearInterval(interval);
  //           })
  //           .catch((err) => {
  //             console.warn('Stripe show() error:', err);
  //           });
  //       } catch (err) {
  //         console.error('paymentRequest.show() err:', err);
  //       }
  //     }, 300);
  
  //     const timeout = setTimeout(() => {
  //       clearInterval(interval);
  //       console.warn('Stopped trying to show Stripe Payment Request after timeout');
  //     }, 5000);
  
  //     return () => {
  //       clearInterval(interval);
  //       clearTimeout(timeout);
  //     };
  //   }
  // }, [paymentRequest, decryptedData]);  

  return (
    <>
      <div className="py-10 button-style">
        {paymentRequest ? (
          <PaymentRequestButtonElement options={{ paymentRequest }} />
        ) : (
          <p>Please wait...</p>
        )}
      </div>
    </>
  );
  
};

export default ApplePay;